// extracted by css-extract-rspack-plugin
export default {"card":"card-ncH4Ww"};